var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "show-packages-rate" },
    [
      _c("v-card-title", [
        _c("span", { staticClass: "text-h5 mobile-text-f16" }, [
          _vm._v("REVIEW RENTAL RATES"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "p-4" },
        [
          _c(
            "v-row",
            { staticClass: "mb-8" },
            [
              _vm.$store.state.resources.config.special_period_control == 1 &&
              _vm.is_in_special_period
                ? _c(
                    "v-col",
                    {
                      staticClass: "align-item-center red--text h6",
                      attrs: { cols: "12", md: "10" },
                    },
                    [
                      _vm.special_period_rate_type == "percent"
                        ? _c("span", [
                            _vm._v(
                              "\n                    Note: We have a special period from " +
                                _vm._s(_vm.special_period_start_date) +
                                " to " +
                                _vm._s(_vm.special_period_end_date) +
                                " and have " +
                                _vm._s(_vm.special_period_increase) +
                                "% increase rate on all packages.\n                "
                            ),
                          ])
                        : _vm.special_period_rate_type === "fixed"
                        ? _c("span", [
                            _vm._v(
                              "\n                    Note: We have a special period from " +
                                _vm._s(_vm.special_period_start_date) +
                                " to " +
                                _vm._s(_vm.special_period_end_date) +
                                " and have " +
                                _vm._s(
                                  _vm._money(_vm.special_period_increase)
                                ) +
                                " increase rate on all packages.\n                "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "align-item-center",
                  attrs: { cols: "12", md: "10" },
                },
                [
                  _vm._v(
                    "\n                This page lists all our prices, please click NEXT at the bottom of the page to actually select your package on the next page\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "text-right", attrs: { cols: "12", md: "2" } },
                [
                  _c(
                    "v-btn",
                    { attrs: { color: "primary" }, on: { click: _vm.Next } },
                    [_vm._v("Next")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mobile-block" },
            [
              _vm._l(_vm.packages, function (package_categorie) {
                return [
                  _c(
                    "v-row",
                    { staticClass: "border-bottom" },
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("h5", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(package_categorie.title)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(package_categorie.items, function (item) {
                    return [
                      _c(
                        "v-row",
                        { staticClass: "package-border hovered-element" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-row",
                                { staticClass: "border-bottom border-bottom" },
                                [
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "span",
                                      { staticClass: "text-primary" },
                                      [
                                        _vm._v(_vm._s(item.title) + " "),
                                        _vm.discount !== 0 &&
                                        _vm.discount_type == "percentage" &&
                                        !_vm.$store.state.model.reservation
                                          .is_seasonal &&
                                        _vm.$store.state.model.reservation
                                          ._type !== "kiosk" &&
                                        _vm.config.module_type_enabled != 0 &&
                                        _vm.config.module_type == "module_13"
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(_vm.discount) +
                                                  "% Discount)"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type == "module_13"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("Day 2 to 5 rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day2_5) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("Day 6+ rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_6_plus) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_9"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("Day 2 to 3 rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day2_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("Day 4+ rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_4_plus) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal &&
                                    _vm.$store.state.model.reservation._type ==
                                      "kiosk"
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("1/2 Day rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.half_day_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("Night rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.night_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_10"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("Day 2 rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day2_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Additional day rate"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      item.additional_day_rate
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_12"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.$store.state.model.reservation
                                      .single_day_type == "multiday" ||
                                    _vm.$store.state.model.reservation._type ==
                                      "kiosk"
                                      ? [
                                          !_vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "border-bottom",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mobile-text-f12",
                                                        },
                                                        [_vm._v("Day 2")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "4" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.day_2_Rate
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "border-bottom",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mobile-text-f12",
                                                        },
                                                        [_vm._v("Day 3")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "4" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.day_3_Rate
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "border-bottom",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mobile-text-f12",
                                                        },
                                                        [_vm._v("Day 4")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "4" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.day_4_Rate
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "border-bottom",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mobile-text-f12",
                                                        },
                                                        [_vm._v("Day 5")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "4" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.day_5_Rate
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "border-bottom",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mobile-text-f12",
                                                        },
                                                        [_vm._v("Additional")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "4" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.additional_day_rate
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      : [
                                          !_vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "border-bottom",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mobile-text-f12",
                                                        },
                                                        [_vm._v("Afternoon")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "4" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.halfDayRate
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "border-bottom",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mobile-text-f12",
                                                        },
                                                        [_vm._v("Night")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "4" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.nightRate
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "border-bottom",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mobile-text-f12",
                                                        },
                                                        [_vm._v("Morning")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "4" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.morningRate
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "border-bottom",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mobile-text-f12",
                                                        },
                                                        [_vm._v("Twilight")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "4" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.twilightRate
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "border-bottom",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mobile-text-f12",
                                                        },
                                                        [_vm._v("Beech Pass")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "4" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.beechPassRate
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                  ]
                                : _vm.frontend_view_folder == "frontend.skigd"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _vm.$store.state.model
                                                  .reservation
                                                  .single_day_type ==
                                                "afternoon"
                                                  ? [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mobile-text-f12",
                                                        },
                                                        [_vm._v("Afternoon")]
                                                      ),
                                                    ]
                                                  : [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mobile-text-f12",
                                                        },
                                                        [_vm._v("Night")]
                                                      ),
                                                    ],
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm.$store.state.model
                                                  .reservation
                                                  .single_day_type ==
                                                "afternoon"
                                                  ? [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            item.half_day_rate
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            item.night_rate
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.multi_day_title
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm.is_in_special_period &&
                                                !_vm.$store.state.model
                                                  .reservation.is_seasonal
                                                  ? [
                                                      _vm._v(
                                                        "\n                                            $" +
                                                          _vm._s(
                                                            _vm.getSpecialRate(
                                                              item.multi_day_rate
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            item.multi_day_rate
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_17"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("Night")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.night_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.multi_day_title
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm.is_in_special_period &&
                                                !_vm.$store.state.model
                                                  .reservation.is_seasonal
                                                  ? [
                                                      _vm._v(
                                                        "\n                                            $" +
                                                          _vm._s(
                                                            _vm.getSpecialRate(
                                                              item.multi_day_rate
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            item.multi_day_rate
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_16"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("2 Day")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day2_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("3-4 Day")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day3_4_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("5+ Day")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_5_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.frontend_view_folder ==
                                  "frontend.nmsportsystems"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("3 to 4 Day")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day3_4_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("5 to 6 Day")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day5_6_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("7+ Day")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_7_plus) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_14"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal rate"),
                                                  ])
                                                : _c("span", [_vm._v("1 Day")]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("2-3 Day")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day2_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("4+ Day")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_4_plus) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.frontend_view_folder ==
                                    "frontend.gallatin" ||
                                  _vm.frontend_view_folder ==
                                    "frontend.tygart" ||
                                  (_vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_3")
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal rate"),
                                                  ])
                                                : _c("span", [_vm._v("1 Day")]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("2-3 Day")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day3_4_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("4+ Day")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_4_plus) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.frontend_view_folder ==
                                  "frontend.ridesnow"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal rate"),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      "Mid-Week Rate (M-TH) "
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Weekend / Holiday Rate"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.holiday_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_18"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal rate"),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      "Mid-Week Rate (M-F) "
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Weekend / Holiday Rate"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.holiday_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("Night Skiing")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.night_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_6"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal rate"),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      "Mid-Week Rate (M-TH) "
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Weekend / Holiday Rate"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.holiday_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("Night Skiing")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.night_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_11"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal rate"),
                                                  ])
                                                : _c("span", [
                                                    _vm._v("1st Day Rate"),
                                                  ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("2nd Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_2_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("3rd Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_3_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("3 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      item.additional_day_rate
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.frontend_view_folder == "frontend.plaines"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal rate"),
                                                  ])
                                                : _c("span", [
                                                    _vm._v("1st Day Rate"),
                                                  ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.multi_day_title
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      item.multi_day_rate
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("3rd Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_7_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.frontend_view_folder ==
                                  "frontend.mtshastasports"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal rate"),
                                                  ])
                                                : _c("span", [
                                                    _vm._v("1 Day Rate"),
                                                  ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("2 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_2_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("3+ day Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_3_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.frontend_view_folder ==
                                    "frontend.basin" ||
                                  (_vm.config.module_type_enabled != 0 &&
                                    (_vm.config.module_type == "module_5" ||
                                      _vm.config.module_type == "module_8"))
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal rate"),
                                                  ])
                                                : _c("span", [
                                                    _vm._v("1 Day Rate"),
                                                  ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("2 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_2_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("3 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_3_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("4 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_4_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("5 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_5_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("6 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_6_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal &&
                                    _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type !== "module_8" &&
                                    _vm.showSevenDayRate
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("7 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_7_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal &&
                                    _vm.frontend_view_folder ==
                                      "frontend.winterpark"
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("8 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_8_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal &&
                                    _vm.frontend_view_folder ==
                                      "frontend.winterpark"
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("9 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_9_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_5_2"
                                ? [
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("1/2 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.half_day_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal rate"),
                                                  ])
                                                : _c("span", [
                                                    _vm._v("1 Day Rate"),
                                                  ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("2 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_2_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("3 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_3_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("4 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_4_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("5 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_5_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("6 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_6_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal &&
                                    _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type !== "module_8" &&
                                    _vm.showSevenDayRate
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("7 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_7_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_5_3"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "4" } },
                                          [
                                            _vm.is_in_special_period &&
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? [
                                                  _vm._v(
                                                    "\n                                            $" +
                                                      _vm._s(
                                                        _vm.getSpecialRate(
                                                          item.daily_rate
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(item.daily_rate) +
                                                      "\n                                        "
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.multi_day_title
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm.is_in_special_period &&
                                                !_vm.$store.state.model
                                                  .reservation.is_seasonal
                                                  ? [
                                                      _vm._v(
                                                        "\n                                            $" +
                                                          _vm._s(
                                                            _vm.getSpecialRate(
                                                              item.multi_day_rate
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            item.multi_day_rate
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal &&
                                    _vm.$store.state.model.reservation._type !==
                                      "kiosk" &&
                                    _vm.discount !== 0 &&
                                    _vm.discount_type == "percentage"
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Advance Reservation "
                                                    ),
                                                    _vm.discount !== 0 &&
                                                    _vm.discount_type ==
                                                      "percentage"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                _vm.discount
                                                              ) +
                                                              "% Discount)"
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.online_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("1/2 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.half_day_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_5_1"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal rate"),
                                                  ])
                                                : _c("span", [
                                                    _vm._v("1 Day Rate"),
                                                  ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("2 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_2_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("3 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_3_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.frontend_view_folder ==
                                    "frontend.rootsrentals" ||
                                  _vm.frontend_view_folder ==
                                    "frontend.stowe" ||
                                  (_vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_4")
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal rate"),
                                                  ])
                                                : _c("span", [
                                                    _vm._v("1 Day Rate"),
                                                  ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("2 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_2_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("3 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_3_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("4 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_4_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("5 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_5_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.frontend_view_folder ==
                                  "frontend.pinnacle"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal && _vm.multi_day_is_enabled
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.multi_day_title
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      item.additional_day_rate
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.$store.state.model.reservation
                                    .single_day_type == "day_hours" ||
                                  _vm.$store.state.model.reservation
                                    .single_day_type == "night_hours"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _vm._v(
                                            "\n                                        Weekends and Holiday\n                                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                item.weekends_and_holiday
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _vm._v(
                                            "\n                                        Week Days, Non Holiday\n                                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                item.week_days_non_holiday
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _vm._v(
                                            "\n                                        Night Hours\n                                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.night_hours) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_7"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "4" } },
                                          [
                                            _vm.$store.state.model.reservation
                                              ._type == "kiosk" &&
                                            !_vm.is_advance_seasonal
                                              ? [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(item.daily_rate) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(item.online_rate) +
                                                      "\n                                        "
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.multi_day_title
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? _c(
                                                  "v-col",
                                                  { attrs: { cols: "4" } },
                                                  [
                                                    _vm.is_in_special_period &&
                                                    !_vm.$store.state.model
                                                      .reservation.is_seasonal
                                                      ? [
                                                          _vm._v(
                                                            "\n                                            $" +
                                                              _vm._s(
                                                                _vm.getSpecialRate(
                                                                  item.multi_day_rate
                                                                )
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      : [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                item.multi_day_rate
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ],
                                                  ],
                                                  2
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("7+ Days rates")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm.is_in_special_period &&
                                                !_vm.$store.state.model
                                                  .reservation.is_seasonal
                                                  ? [
                                                      _vm._v(
                                                        "\n                                            $" +
                                                          _vm._s(
                                                            _vm.getSpecialRate(
                                                              item.day_7_plus
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            item.day_7_plus
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm.config.module_type_enabled != 0 &&
                                  _vm.config.module_type == "module_19"
                                ? [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "4" } }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.online_rate) +
                                              "\n                                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("4 Day Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.day_4_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [_vm._v("Weekly Rate")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.week_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : [
                                    _c(
                                      "v-row",
                                      { staticClass: "border-bottom" },
                                      [
                                        _c("v-col", { attrs: { cols: "8" } }, [
                                          _c(
                                            "span",
                                            { staticClass: "mobile-text-f12" },
                                            [
                                              _vm.$store.state.model.reservation
                                                .is_seasonal
                                                ? _c("span", [
                                                    _vm._v("Seasonal"),
                                                  ])
                                                : _c("span", [_vm._v("Daily")]),
                                              _vm._v(" rate"),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "4" } },
                                          [
                                            _vm.is_in_special_period &&
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? [
                                                  _vm._v(
                                                    "\n                                            $" +
                                                      _vm._s(
                                                        _vm.getSpecialRate(
                                                          item.daily_rate
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(item.daily_rate) +
                                                      "\n                                        "
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.multi_day_title
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm.is_in_special_period &&
                                                !_vm.$store.state.model
                                                  .reservation.is_seasonal
                                                  ? [
                                                      _vm._v(
                                                        "\n                                            $" +
                                                          _vm._s(
                                                            _vm.getSpecialRate(
                                                              item.multi_day_rate
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            item.multi_day_rate
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal &&
                                    _vm.$store.state.model.reservation._type !==
                                      "kiosk" &&
                                    _vm.discount !== 0 &&
                                    _vm.discount_type == "percentage"
                                      ? _c(
                                          "v-row",
                                          { staticClass: "border-bottom" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-text-f12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Advance Reservation "
                                                    ),
                                                    _vm.discount !== 0 &&
                                                    _vm.discount_type ==
                                                      "percentage"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                _vm.discount
                                                              ) +
                                                              "% Discount)"
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.online_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  }),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "desktop-block" },
            [
              _c(
                "v-row",
                { staticClass: "bg-light border-bottom" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: _vm.title_col, md: _vm.title_col } },
                    [
                      _vm._v("\n                    EQUIPMENT PACKAGE "),
                      _vm.discount !== 0 &&
                      _vm.discount_type == "percentage" &&
                      !_vm.$store.state.model.reservation.is_seasonal &&
                      _vm.$store.state.model.reservation._type !== "kiosk" &&
                      _vm.config.module_type_enabled != 0 &&
                      (_vm.config.module_type == "module_9" ||
                        _vm.config.module_type == "module_13")
                        ? _c("span", [
                            _vm._v("(" + _vm._s(_vm.discount) + "% Discount)"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.$store.state.model.reservation.is_delivery
                    ? [
                        _c(
                          "v-col",
                          {
                            staticClass: "text-center",
                            attrs: { cols: _vm.daily_col, md: _vm.daily_col },
                          },
                          [
                            _vm._v(
                              "\n                        Delivery rate\n                    "
                            ),
                          ]
                        ),
                      ]
                    : [
                        _vm.config.module_type_enabled != 0 &&
                        _vm.config.module_type == "module_13"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal")])
                                    : _c("span", [_vm._v("Daily")]),
                                  _vm._v(" rate\n                        "),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Day 2 to 5 rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Day 6+ rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.frontend_view_folder == "frontend.skigd"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal")])
                                    : _c("span", [_vm._v("Daily")]),
                                  _vm._v(" rate\n                        "),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm.$store.state.model.reservation
                                        .single_day_type == "afternoon"
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "mobile-text-f12",
                                              },
                                              [_vm._v("Afternoon")]
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "mobile-text-f12",
                                              },
                                              [_vm._v("Night")]
                                            ),
                                          ],
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.multi_day_is_enabled
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.multi_day_title) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_17"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal")])
                                    : _c("span", [_vm._v("Daily")]),
                                  _vm._v(" rate\n                        "),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mobile-text-f12" },
                                        [_vm._v("Night")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.multi_day_is_enabled
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.multi_day_title) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_16"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal rate")])
                                    : _c("span", [_vm._v("1 Day")]),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            2 Day\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            3-4 Day\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            5+ Days\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.frontend_view_folder ==
                            "frontend.nmsportsystems"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal rate")])
                                    : _c("span", [_vm._v("1 Day")]),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            3 to 4 Day\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            5 to 6 Day\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            7+ Days\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_14"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal rate")])
                                    : _c("span", [_vm._v("1 Day")]),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            2-3 Days\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            4+ Days\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.frontend_view_folder == "frontend.gallatin" ||
                            _vm.frontend_view_folder == "frontend.tygart" ||
                            (_vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type == "module_3")
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal rate")])
                                    : _c("span", [_vm._v("Day 1 to 2 rate")]),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Day 3 to 4 rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Day 5 + rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.frontend_view_folder == "frontend.ridesnow"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$store.state.model.reservation
                                          .is_seasonal
                                          ? "Seasonal rate"
                                          : "Mid-Week Rate (M-TH)"
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Weekend / Holiday Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_18"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$store.state.model.reservation
                                          .is_seasonal
                                          ? "Seasonal rate"
                                          : "Mid-Week Rate (M-F)"
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Weekend / Holiday Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                           Night Skiing\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_6"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$store.state.model.reservation
                                          .is_seasonal
                                          ? "Seasonal rate"
                                          : "Mid-Week Rate (M-TH)"
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Weekend / Holiday Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                           Night Skiing\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_11"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$store.state.model.reservation
                                          .is_seasonal
                                          ? "Seasonal rate"
                                          : "1st Day Rate"
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            2nd Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            3rd Day Rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Additional Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.frontend_view_folder == "frontend.plaines"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$store.state.model.reservation
                                          .is_seasonal
                                          ? "Seasonal rate"
                                          : "Daily rate "
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.multi_day_title) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Weekly rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.frontend_view_folder ==
                            "frontend.mtshastasports"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$store.state.model.reservation
                                          .is_seasonal
                                          ? "Seasonal rate"
                                          : "1 Day Rate"
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            2 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            3+ Day Rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.frontend_view_folder == "frontend.basin" ||
                            (_vm.config.module_type_enabled != 0 &&
                              (_vm.config.module_type == "module_5" ||
                                _vm.config.module_type == "module_8"))
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$store.state.model.reservation
                                          .is_seasonal
                                          ? "Seasonal rate"
                                          : "1 Day Rate"
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            2 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            3 Day Rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            4 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            5 Day Rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            6 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.showSevenDayRate
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            7 Day Rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.showSevenDayRate &&
                              _vm.frontend_view_folder == "frontend.winterpark"
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            8 Day Rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.showSevenDayRate &&
                              _vm.frontend_view_folder == "frontend.winterpark"
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            9 Day Rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type !== "module_8"
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Additional Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_5_2"
                          ? [
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            1/2 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$store.state.model.reservation
                                          .is_seasonal
                                          ? "Seasonal rate"
                                          : "1 Day Rate"
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            2 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            3 Day Rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            4 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            5 Day Rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            6 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.showSevenDayRate
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            7 Day Rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type !== "module_8"
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Additional Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_5_3"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal")])
                                    : _c("span", [_vm._v("Daily")]),
                                  _vm._v(" rate\n                        "),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.multi_day_is_enabled
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.multi_day_title) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.discount !== 0 &&
                              _vm.discount_type == "percentage" &&
                              _vm.$store.state.model.reservation._type !==
                                "kiosk" &&
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Advance Reservation "
                                      ),
                                      _vm.discount !== 0 &&
                                      _vm.discount_type == "percentage"
                                        ? _c("span", [
                                            _vm._v(
                                              "(" +
                                                _vm._s(_vm.discount) +
                                                "% Discount)"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            1/2 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_5_1"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$store.state.model.reservation
                                          .is_seasonal
                                          ? "Seasonal rate"
                                          : "1 Day Rate"
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            2 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            3 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Additional Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.frontend_view_folder ==
                              "frontend.rootsrentals" ||
                            _vm.frontend_view_folder == "frontend.stowe" ||
                            (_vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type == "module_4")
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$store.state.model.reservation
                                          .is_seasonal
                                          ? "Seasonal rate"
                                          : "1 Day Rate"
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            2 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            3 Day Rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            4 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            5 Day Rate\n                       "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Additional Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_9"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal")])
                                    : _c("span", [_vm._v("Daily")]),
                                  _vm._v(" rate\n                        "),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Day 2 to 3 rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Day 4+ rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.$store.state.model.reservation._type ==
                                "kiosk"
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            1/2 Day rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Night rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_10"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal")])
                                    : _c("span", [_vm._v("Daily")]),
                                  _vm._v(" rate\n                        "),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Day 2 rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Additional day rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_12"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: { cols: "2" },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal")])
                                    : _c("span", [_vm._v("Daily")]),
                                  _vm._v(" rate\n                        "),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.$store.state.model.reservation
                                .single_day_type == "multiday" ||
                              _vm.$store.state.model.reservation._type ==
                                "kiosk"
                                ? [
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Day 2\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Day 3\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Day 4\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Day 5\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center",
                                            attrs: { cols: "2" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Additional\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : [
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center",
                                            attrs: { cols: "2" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Afternoon\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Night\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Morning\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Twilight\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$store.state.model.reservation
                                      .is_seasonal
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "text-center",
                                            attrs: { cols: "2" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Beech Pass\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                            ]
                          : _vm.frontend_view_folder == "frontend.pinnacle"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal")])
                                    : _c("span", [_vm._v("Daily")]),
                                  _vm._v(" rate\n                        "),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.multi_day_is_enabled
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.multi_day_title) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.$store.state.model.reservation
                              .single_day_type == "day_hours" ||
                            _vm.$store.state.model.reservation
                              .single_day_type == "night_hours"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            Weekends and Holiday\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.online_col,
                                    md: _vm.online_col,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            Week Days, Non Holiday\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.multi_day_is_enabled
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Night Hours\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_7"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal")])
                                    : _c("span", [_vm._v("Daily")]),
                                  _vm._v(" rate\n                        "),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.multi_day_title) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            7+ days rates\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm.config.module_type_enabled != 0 &&
                            _vm.config.module_type == "module_19"
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal rate")])
                                    : _c("span", [_vm._v("Daily rate")]),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            4 Day Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.daily_col,
                                        md: _vm.daily_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Weekly Rate\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    cols: _vm.daily_col,
                                    md: _vm.daily_col,
                                  },
                                },
                                [
                                  _vm.$store.state.model.reservation.is_seasonal
                                    ? _c("span", [_vm._v("Seasonal")])
                                    : _c("span", [_vm._v("Daily")]),
                                  _vm._v(" rate\n                        "),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.$store.state.model.reservation.is_seasonal &&
                              _vm.multi_day_is_enabled
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.multi_col,
                                        md: _vm.multi_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.multi_day_title) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.discount !== 0 &&
                              _vm.discount_type == "percentage" &&
                              _vm.$store.state.model.reservation._type !==
                                "kiosk" &&
                              !_vm.$store.state.model.reservation.is_seasonal
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: _vm.online_col,
                                        md: _vm.online_col,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Advance Reservation "
                                      ),
                                      _vm.discount !== 0 &&
                                      _vm.discount_type == "percentage"
                                        ? _c("span", [
                                            _vm._v(
                                              "(" +
                                                _vm._s(_vm.discount) +
                                                "% Discount)"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _vm._l(_vm.packages, function (package_categorie) {
                return [
                  _c(
                    "v-row",
                    { staticClass: "border-bottom" },
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("h5", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(package_categorie.title)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(package_categorie.items, function (item) {
                    return [
                      _c(
                        "v-row",
                        { staticClass: "border-bottom hovered-element" },
                        [
                          _c(
                            "v-col",
                            {
                              attrs: { cols: _vm.title_col, md: _vm.title_col },
                            },
                            [
                              item.description !== null
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "span",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "text-light-blue",
                                                      },
                                                      "span",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "\n                                   " +
                                                        _vm._s(item.title) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(item.description),
                                        },
                                      }),
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(item.title) +
                                        "\n                        "
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.$store.state.model.reservation.is_delivery
                            ? [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "text-center",
                                    attrs: {
                                      cols: _vm.daily_col,
                                      md: _vm.daily_col,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.current_rate) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _vm.config.module_type_enabled != 0 &&
                                _vm.config.module_type == "module_13"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.online_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.online_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day2_5) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_6_plus) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.frontend_view_folder == "frontend.skigd"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.online_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.online_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm.$store.state.model.reservation
                                                .single_day_type == "afternoon"
                                                ? [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.half_day_rate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.night_rate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ],
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal && _vm.multi_day_is_enabled
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm.is_in_special_period &&
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? [
                                                    _vm._v(
                                                      "\n                                        $" +
                                                        _vm._s(
                                                          _vm.getSpecialRate(
                                                            item.multi_day_rate
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.multi_day_rate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ],
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_16"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day2_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day3_4_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_5_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.frontend_view_folder ==
                                    "frontend.nmsportsystems"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day3_4_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day5_6_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_7_plus) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_14"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day2_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_4_plus) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.frontend_view_folder ==
                                      "frontend.gallatin" ||
                                    _vm.frontend_view_folder ==
                                      "frontend.tygart" ||
                                    (_vm.config.module_type_enabled != 0 &&
                                      _vm.config.module_type == "module_3")
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day3_4_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_4_plus) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.frontend_view_folder ==
                                    "frontend.ridesnow"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.holiday_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    (_vm.config.module_type == "module_6" ||
                                      _vm.config.module_type == "module_18")
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.holiday_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.night_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_11"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_2_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_3_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    item.additional_day_rate
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.frontend_view_folder ==
                                    "frontend.plaines"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.multi_day_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_7_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.frontend_view_folder ==
                                    "frontend.mtshastasports"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_2_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_3_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.frontend_view_folder ==
                                      "frontend.basin" ||
                                    (_vm.config.module_type_enabled != 0 &&
                                      (_vm.config.module_type == "module_5" ||
                                        _vm.config.module_type == "module_8"))
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_2_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_3_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_4_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_5_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_6_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal && _vm.showSevenDayRate
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_7_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal &&
                                      _vm.showSevenDayRate &&
                                      _vm.frontend_view_folder ==
                                        "frontend.winterpark"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_8_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal &&
                                      _vm.showSevenDayRate &&
                                      _vm.frontend_view_folder ==
                                        "frontend.winterpark"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_9_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal &&
                                      _vm.config.module_type_enabled != 0 &&
                                      _vm.config.module_type !== "module_8"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    item.additional_day_rate
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_5_2"
                                  ? [
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.half_day_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_2_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_3_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_4_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_5_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_6_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal && _vm.showSevenDayRate
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_7_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal &&
                                      _vm.config.module_type_enabled != 0 &&
                                      _vm.config.module_type !== "module_8"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    item.additional_day_rate
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_5_3"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm.is_in_special_period &&
                                          !_vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? [
                                                _vm._v(
                                                  "\n                                        $" +
                                                    _vm._s(
                                                      _vm.getSpecialRate(
                                                        item.daily_rate
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.daily_rate) +
                                                    "\n                                    "
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal && _vm.multi_day_is_enabled
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm.is_in_special_period &&
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? [
                                                    _vm._v(
                                                      "\n                                        $" +
                                                        _vm._s(
                                                          _vm.getSpecialRate(
                                                            item.multi_day_rate
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.multi_day_rate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ],
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.discount !== 0 &&
                                      _vm.discount_type == "percentage" &&
                                      _vm.$store.state.model.reservation
                                        ._type !== "kiosk" &&
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.online_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.online_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.half_day_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_5_1"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_2_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_3_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    item.additional_day_rate
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.frontend_view_folder ==
                                      "frontend.rootsrentals" ||
                                    _vm.frontend_view_folder ==
                                      "frontend.stowe" ||
                                    (_vm.config.module_type_enabled != 0 &&
                                      _vm.config.module_type == "module_4")
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.daily_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_2_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.daily_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_3_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.daily_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_4_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.daily_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_5_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.daily_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    item.additional_day_rate
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_17"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.online_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.online_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.night_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal && _vm.multi_day_is_enabled
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm.is_in_special_period &&
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? [
                                                    _vm._v(
                                                      "\n                                        $" +
                                                        _vm._s(
                                                          _vm.getSpecialRate(
                                                            item.multi_day_rate
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.multi_day_rate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ],
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_9"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.online_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.online_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day2_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_4_plus) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal &&
                                      _vm.$store.state.model.reservation
                                        ._type == "kiosk"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.half_day_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.night_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_10"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.online_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.online_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day2_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    item.additional_day_rate
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_12"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: { cols: "2" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.online_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.$store.state.model.reservation
                                        .single_day_type == "multiday" ||
                                      _vm.$store.state.model.reservation
                                        ._type == "kiosk"
                                        ? [
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { cols: "1" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.day_2_Rate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { cols: "1" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.day_3_Rate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { cols: "1" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.day_4_Rate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { cols: "1" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.day_5_Rate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { cols: "2" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.additional_day_rate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        : [
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { cols: "2" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.halfDayRate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { cols: "1" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(item.nightRate) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { cols: "1" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.morningRate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { cols: "1" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.twilightRate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { cols: "2" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.beechPassRate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                    ]
                                  : _vm.frontend_view_folder ==
                                    "frontend.pinnacle"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.online_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal && _vm.multi_day_is_enabled
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    item.additional_day_rate
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.$store.state.model.reservation
                                      .single_day_type == "day_hours" ||
                                    _vm.$store.state.model.reservation
                                      .single_day_type == "night_hours"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                item.weekends_and_holiday
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.online_col,
                                            md: _vm.online_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                item.week_days_non_holiday
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.multi_col,
                                            md: _vm.multi_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.night_hours) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_7"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm.$store.state.model.reservation
                                            ._type == "kiosk" &&
                                          !_vm.is_advance_seasonal
                                            ? [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.daily_rate) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.online_rate) +
                                                    "\n                                    "
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm.is_in_special_period &&
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? [
                                                    _vm._v(
                                                      "\n                                        $" +
                                                        _vm._s(
                                                          _vm.getSpecialRate(
                                                            item.multi_day_rate
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.multi_day_rate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ],
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.online_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_7_plus) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm.config.module_type_enabled != 0 &&
                                    _vm.config.module_type == "module_19"
                                  ? [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.current_rate) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.day_4_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.daily_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.week_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: _vm.daily_col,
                                            md: _vm.daily_col,
                                          },
                                        },
                                        [
                                          _vm.is_in_special_period &&
                                          !_vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? [
                                                _vm._v(
                                                  "\n                                        $" +
                                                    _vm._s(
                                                      _vm.getSpecialRate(
                                                        item.daily_rate
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.daily_rate) +
                                                    "\n                                    "
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal && _vm.multi_day_is_enabled
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.multi_col,
                                                md: _vm.multi_col,
                                              },
                                            },
                                            [
                                              _vm.is_in_special_period &&
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? [
                                                    _vm._v(
                                                      "\n                                        $" +
                                                        _vm._s(
                                                          _vm.getSpecialRate(
                                                            item.multi_day_rate
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.multi_day_rate
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ],
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.discount !== 0 &&
                                      _vm.discount_type == "percentage" &&
                                      _vm.$store.state.model.reservation
                                        ._type !== "kiosk" &&
                                      !_vm.$store.state.model.reservation
                                        .is_seasonal
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                cols: _vm.online_col,
                                                md: _vm.online_col,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.online_rate) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                              ],
                        ],
                        2
                      ),
                    ]
                  }),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "mt-8 mb-3 justify-content-end" },
            [
              _c(
                "v-col",
                { staticClass: "text-right", attrs: { cols: "12", md: "2" } },
                [
                  _c(
                    "v-btn",
                    { attrs: { color: "primary" }, on: { click: _vm.Next } },
                    [_vm._v("Next")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }